export enum UserType {
  Internal = 'INTERNAL',
  Company = 'COMPANY',
  Vendor = 'VENDOR',
}
